/* FarmSteady — instruction-page engagement (farmsteady-instruction section).
 *
 * Loaded ONLY by the instruction template (no global JS). Three jobs,
 * all progressive enhancement — the page reads fine without any of it:
 *
 * 1. Step check-off — fs-recipe-steps renders a per-step button when
 *    checkable: true; this wires it up and persists checked state in
 *    localStorage keyed by page handle (kitchen sessions survive
 *    reloads). Buttons stay display:none until .fs-instruction--ready.
 * 2. Top-of-viewport progress bar — fills as the user scrolls through
 *    the directions (motion exception: useful-confirms-action only).
 * 3. Legacy fixup — not-yet-migrated pages render raw Shogun body_html;
 *    Shogun's lazyloader is gone, so copy data-src -> src.
 */

(() => {
  const init = () => {
    const root = document.querySelector('[data-fs-instruction]');
    if (!root) return;

    /* ---- legacy Shogun lazyload fixup ---- */
    root.querySelectorAll('[data-fs-legacy] img[data-src], [data-fs-legacy] iframe[data-src]').forEach((el) => {
      if (!el.getAttribute('src')) el.setAttribute('src', el.getAttribute('data-src'));
    });

    /* ---- step check-off (localStorage) ---- */
    const storageKey = `fs-instruction:${root.dataset.fsHandle || window.location.pathname}`;
    const store = {
      read() {
        try {
          return new Set(JSON.parse(window.localStorage.getItem(storageKey) || '[]'));
        } catch {
          return new Set();
        }
      },
      write(done) {
        try {
          window.localStorage.setItem(storageKey, JSON.stringify([...done]));
        } catch {
          /* private mode — check-off still works for the session */
        }
      },
    };

    const steps = [...root.querySelectorAll('[data-fs-step]')];
    if (steps.length) {
      const done = store.read();
      const apply = (step, index, isDone) => {
        step.classList.toggle('is-done', isDone);
        const button = step.querySelector('[data-fs-step-check]');
        if (button) button.setAttribute('aria-pressed', String(isDone));
      };
      steps.forEach((step, index) => {
        apply(step, index, done.has(index));
        const button = step.querySelector('[data-fs-step-check]');
        if (!button) return;
        button.addEventListener('click', () => {
          const isDone = !done.has(index);
          if (isDone) done.add(index);
          else done.delete(index);
          store.write(done);
          apply(step, index, isDone);
        });
      });
      root.classList.add('fs-instruction--ready');
    }

    /* ---- scroll progress bar ---- */
    const fill = root.querySelector('[data-fs-progress]');
    if (fill) {
      const target = root.querySelector('.fs-recipe__directions') || root;
      let ticking = false;
      const update = () => {
        ticking = false;
        const rect = target.getBoundingClientRect();
        const viewport = window.innerHeight;
        const total = rect.height + viewport * 0.2;
        const passed = viewport - rect.top;
        const progress = Math.min(1, Math.max(0, passed / total));
        fill.style.transform = `scaleX(${progress})`;
      };
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
